import React from "react";
import PropTypes from "prop-types";

import ReactPaginate from "react-paginate";

const Pager = ({ pageCount, activePage, changePage }) => {
    const handleChangePage = (event) => {
        const page = event.selected + 1;

        changePage(page);
        window.scrollTo(0, 0);
    };

    return (
        <div className="react-pager">
            <ReactPaginate
                containerClassName="react-pager"
                breakClassName="react-pager__item"
                pageClassName="react-pager__item"
                activeClassName="is-active"
                previousClassName="react-pager__item--previous"
                nextClassName="react-pager__item--next"
                pageCount={pageCount}
                initialPage={activePage - 1}
                forcePage={activePage - 1}
                disableInitialCallback
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                nextLabel=""
                previousLabel=""
                onPageChange={handleChangePage}
            />
        </div>
    );
};

Pager.propTypes = {
    pageCount: PropTypes.number.isRequired,
    activePage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    changePage: PropTypes.func.isRequired,
};

export default Pager;
